export enum Tenant {
  AIRCONDITIONING = 'Airconditioning',
  HEATPUMPS = 'Heatpumps',
}
